import Axios from "axios";
import {
  readDrafts,
  createDraft,
  deleteDraft,
  addItemToDraft,
  removeItemFromDraft,
  buildGroupConnectPayload,
  buildShareUrl,
} from "../../helpers/fabricGroups";
import {
  SET_GROUP_DRAFTS,
  PUBLISH_GROUP_REQUEST,
  PUBLISH_GROUP_SUCCESS,
  PUBLISH_GROUP_FAILURE,
  FETCH_GROUPS_REQUEST,
  FETCH_GROUPS_SUCCESS,
  FETCH_GROUPS_FAILURE,
} from "../types/fabricGroupTypes";

const API_BASE_URL = "https://cms.vidhaantextiles.com/api";

const setDrafts = (drafts) => ({ type: SET_GROUP_DRAFTS, payload: drafts });

export const loadDrafts = () => (dispatch) =>
  dispatch(setDrafts(readDrafts()));

export const createGroupDraft = (name, description, addToast) => (dispatch) => {
  const draft = createDraft(name, description);
  dispatch(setDrafts(readDrafts()));
  if (addToast) {
    addToast(`Created "${draft.name}"`, {
      appearance: "success",
      autoDismiss: true,
    });
  }
  return draft;
};

export const addProductToDraft =
  (localId, product, itemType, addToast) => (dispatch) => {
    dispatch(setDrafts(addItemToDraft(localId, product, itemType)));
    if (addToast) {
      addToast("Added to group", { appearance: "success", autoDismiss: true });
    }
  };

export const removeProductFromDraft =
  (localId, id, itemType) => (dispatch) =>
    dispatch(setDrafts(removeItemFromDraft(localId, id, itemType)));

export const deleteGroupDraft = (localId, addToast) => (dispatch) => {
  dispatch(setDrafts(deleteDraft(localId)));
  if (addToast) {
    addToast("Group deleted", { appearance: "success", autoDismiss: true });
  }
};

// Creates the Strapi entry. The local draft is only dropped after a 2xx, so a
// failed publish never loses the admin's work.
export const publishGroup = (draft, addToast) => async (dispatch) => {
  const token = localStorage.getItem("token");
  if (!token) {
    if (addToast) {
      addToast("Please login to publish a group", {
        appearance: "warning",
        autoDismiss: true,
      });
    }
    return null;
  }

  dispatch({ type: PUBLISH_GROUP_REQUEST });

  try {
    const response = await Axios.post(
      `${API_BASE_URL}/fabric-groups`,
      {
        data: {
          name: draft.name,
          description: draft.description || "",
          ...buildGroupConnectPayload(draft),
          // fabric-group has draft/publish enabled, so without this the entry
          // is created unpublished and the share page resolves to null.
          publishedAt: new Date().toISOString(),
        },
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const publishedId = response.data?.data?.id;
    dispatch(setDrafts(deleteDraft(draft.localId)));
    dispatch({ type: PUBLISH_GROUP_SUCCESS, payload: publishedId });
    dispatch(fetchPublishedGroups());

    if (addToast) {
      addToast(`"${draft.name}" published`, {
        appearance: "success",
        autoDismiss: true,
      });
    }
    return { id: publishedId, shareUrl: buildShareUrl(publishedId) };
  } catch (error) {
    const detail =
      error.response?.data?.error?.message || error.message || "Unknown error";
    console.error("Error publishing fabric group:", error);
    dispatch({ type: PUBLISH_GROUP_FAILURE, payload: detail });
    if (addToast) {
      addToast(`Failed to publish: ${detail}`, {
        appearance: "error",
        autoDismiss: true,
      });
    }
    return null;
  }
};

export const fetchPublishedGroups = () => async (dispatch) => {
  const token = localStorage.getItem("token");
  if (!token) return;

  dispatch({ type: FETCH_GROUPS_REQUEST });

  try {
    const response = await Axios.get(
      `${API_BASE_URL}/fabric-groups?populate[fabrics][fields][0]=id&populate[knits][fields][0]=id&populate[stocks][fields][0]=id&pagination[pageSize]=100&sort=id:desc`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: FETCH_GROUPS_SUCCESS,
      payload: response.data?.data || [],
    });
  } catch (error) {
    console.error("Error fetching fabric groups:", error);
    dispatch({ type: FETCH_GROUPS_FAILURE, payload: error.message });
  }
};
